import { render, staticRenderFns } from "./DemoAccountTab.vue?vue&type=template&id=31f45b10"
import script from "./DemoAccountTab.vue?vue&type=script&lang=js"
export * from "./DemoAccountTab.vue?vue&type=script&lang=js"
import style0 from "./DemoAccountTab.vue?vue&type=style&index=0&id=31f45b10&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports